define("media/components/media/grid", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class="o--container">
    <div class="u--row">
      {{#if this.starredMediaItems.length}}
        <div class="u--col__12">
          <div class="u--row">
            {{! Starred Media }}
            <div class="u--col__9 u--text--md u--m__tb__md">
              {{svg-jar "starred" class="o--icon o--icon--yellow u--m__r__xs"}}
              {{t "media_library.starred_media"}}
              <a class="u--text--sm u--text--uppercase u--m__l__sm" {{on "click" this.viewStarredOnCalendar}}>
                {{t "media_library.view_on_calendar"}}
              </a>
            </div>
            {{! Un-Starred Button }}
            <div class="u--col__3 u--m__tb">
              <a
                class="o--btn o--btn--outline u--text--sm u--float--right qa--medialib_unstar_btn"
                {{on "click" @unstarAll}}
              >
                {{t "media_library.unstar_all"}}
              </a>
            </div>
          </div>
          {{! Starred Media List}}
          {{#each this.starredMediaItems as |item|}}
            <div class="cME--mediaWrapper--sm" {{on "click" (fn @removeStarred item bubbles=false)}}>
              <figure class="o--mediaContainer">
                <img class="o--media" src={{item.medThumbnailOrProcessingUrl}} />
  
                <span class="o--media__label--select u--m__xs">
                  <span class="o--media__label--star">
                    {{svg-jar "delete-circle" class="o--media__labelIcon is--unstarred o--icon--md o--icon--white"}}
                  </span>
                </span>
              </figure>
            </div>
          {{/each}}
          <hr class="u--m__b__0" />
        </div>
      {{/if}}
      {{#unless @hasMedia}}
        <div class="o--blank">
          <h2 class="o--blank__title">
            {{t "media_library.empty.title"}}
          </h2>
          <p class="o--blank__desc">
            {{t "media_library.empty.desc"}}
          </p>
          <img alt={{t "media_library.empty.desc"}} class="o--blank__img" src="/assets/images/img--empty__ml.svg" />
        </div>
      {{/unless}}
      {{#if this.fromToday.length}}
        <div class="u--col__12 cME--cardWrapper">
          <p class="u--text--md u--m__tb__md">
            {{t "media_library.today"}}
          </p>
          {{#each this.fromToday as |mediaItem|}}
            <Media::AssetCard
              @addSelection={{@addSelection}}
              @addStarred={{@addStarred}}
              @mediaItem={{mediaItem}}
              @openAssetModal={{@openAssetModal}}
              @removeSelection={{@removeSelection}}
              @removeStarred={{@removeStarred}}
              @selectedAssets={{@selectedAssets}}
            />
          {{/each}}
        </div>
      {{/if}}
      {{#if this.fromLastWeek.length}}
        <div class="u--col__12 cME--cardWrapper">
          <p class="u--text--md u--m__tb__md">
            {{t "media_library.last_week"}}
          </p>
          <div>
            {{#each this.fromLastWeek as |mediaItem|}}
              <Media::AssetCard
                @addSelection={{@addSelection}}
                @addStarred={{@addStarred}}
                @mediaItem={{mediaItem}}
                @openAssetModal={{@openAssetModal}}
                @removeSelection={{@removeSelection}}
                @removeStarred={{@removeStarred}}
                @selectedAssets={{@selectedAssets}}
              />
            {{/each}}
          </div>
        </div>
      {{/if}}
      {{#if this.fromLastMonth.length}}
        <div class="u--col__12 cME--cardWrapper">
          <p class="u--text--md u--m__tb__md">
            {{t "media_library.last_month"}}
          </p>
          <div>
            {{#each this.fromLastMonth as |mediaItem|}}
              <Media::AssetCard
                @addSelection={{@addSelection}}
                @addStarred={{@addStarred}}
                @mediaItem={{mediaItem}}
                @openAssetModal={{@openAssetModal}}
                @removeSelection={{@removeSelection}}
                @removeStarred={{@removeStarred}}
                @selectedAssets={{@selectedAssets}}
              />
            {{/each}}
          </div>
        </div>
      {{/if}}
      {{#if this.fromEarlier.length}}
        <div class="u--col__12 cME--cardWrapper">
          <p class="u--text--md u--m__tb__md">
            {{t "media_library.earlier"}}
          </p>
          <div>
            {{#each this.fromEarlier as |mediaItem|}}
              <Media::AssetCard
                @addSelection={{@addSelection}}
                @addStarred={{@addStarred}}
                @mediaItem={{mediaItem}}
                @openAssetModal={{@openAssetModal}}
                @removeSelection={{@removeSelection}}
                @removeStarred={{@removeStarred}}
                @selectedAssets={{@selectedAssets}}
              />
            {{/each}}
          </div>
        </div>
      {{/if}}
      {{#if @hasMedia}}
        <div class="u--col__12">
          {{#if @queryLoadingMore}}
            <span class="o--btn--sm u--text--light o--btn--block u--m__tb__sm">
              {{t "shared_words.loading"}}
            </span>
          {{else if @canLoadMore}}
            <a class="o--btn--lg o--btn--outline o--btn--block u--text--hl u--m__tb" {{on "click" @loadMore}}>
              {{t "shared_phrases.load_more"}}
            </a>
          {{else}}
            <span class="o--btn--sm u--text--light o--btn--block u--m__tb__sm">
              {{t "shared_phrases.no_more"}}
            </span>
          {{/if}}
        </div>
      {{/if}}
    </div>
  </div>
  */
  {
    "id": "8mYauzg2",
    "block": "[[[10,0],[14,0,\"o--container\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"u--row\"],[12],[1,\"\\n\"],[41,[30,0,[\"starredMediaItems\",\"length\"]],[[[1,\"      \"],[10,0],[14,0,\"u--col__12\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"u--row\"],[12],[1,\"\\n\"],[1,\"          \"],[10,0],[14,0,\"u--col__9 u--text--md u--m__tb__md\"],[12],[1,\"\\n            \"],[1,[28,[35,1],[\"starred\"],[[\"class\"],[\"o--icon o--icon--yellow u--m__r__xs\"]]]],[1,\"\\n            \"],[1,[28,[35,2],[\"media_library.starred_media\"],null]],[1,\"\\n            \"],[11,3],[24,0,\"u--text--sm u--text--uppercase u--m__l__sm\"],[4,[38,3],[\"click\",[30,0,[\"viewStarredOnCalendar\"]]],null],[12],[1,\"\\n              \"],[1,[28,[35,2],[\"media_library.view_on_calendar\"],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"],[1,\"          \"],[10,0],[14,0,\"u--col__3 u--m__tb\"],[12],[1,\"\\n            \"],[11,3],[24,0,\"o--btn o--btn--outline u--text--sm u--float--right qa--medialib_unstar_btn\"],[4,[38,3],[\"click\",[30,1]],null],[12],[1,\"\\n              \"],[1,[28,[35,2],[\"media_library.unstar_all\"],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"],[42,[28,[37,5],[[28,[37,5],[[30,0,[\"starredMediaItems\"]]],null]],null],null,[[[1,\"          \"],[11,0],[24,0,\"cME--mediaWrapper--sm\"],[4,[38,3],[\"click\",[28,[37,6],[[30,3],[30,2]],[[\"bubbles\"],[false]]]],null],[12],[1,\"\\n            \"],[10,\"figure\"],[14,0,\"o--mediaContainer\"],[12],[1,\"\\n              \"],[10,\"img\"],[14,0,\"o--media\"],[15,\"src\",[30,2,[\"medThumbnailOrProcessingUrl\"]]],[12],[13],[1,\"\\n\\n              \"],[10,1],[14,0,\"o--media__label--select u--m__xs\"],[12],[1,\"\\n                \"],[10,1],[14,0,\"o--media__label--star\"],[12],[1,\"\\n                  \"],[1,[28,[35,1],[\"delete-circle\"],[[\"class\"],[\"o--media__labelIcon is--unstarred o--icon--md o--icon--white\"]]]],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[2]],null],[1,\"        \"],[10,\"hr\"],[14,0,\"u--m__b__0\"],[12],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[41,[51,[30,4]],[[[1,\"      \"],[10,0],[14,0,\"o--blank\"],[12],[1,\"\\n        \"],[10,\"h2\"],[14,0,\"o--blank__title\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"media_library.empty.title\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,2],[14,0,\"o--blank__desc\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"media_library.empty.desc\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,\"img\"],[15,\"alt\",[28,[37,2],[\"media_library.empty.desc\"],null]],[14,0,\"o--blank__img\"],[14,\"src\",\"/assets/images/img--empty__ml.svg\"],[12],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"fromToday\",\"length\"]],[[[1,\"      \"],[10,0],[14,0,\"u--col__12 cME--cardWrapper\"],[12],[1,\"\\n        \"],[10,2],[14,0,\"u--text--md u--m__tb__md\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"media_library.today\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"],[42,[28,[37,5],[[28,[37,5],[[30,0,[\"fromToday\"]]],null]],null],null,[[[1,\"          \"],[8,[39,8],null,[[\"@addSelection\",\"@addStarred\",\"@mediaItem\",\"@openAssetModal\",\"@removeSelection\",\"@removeStarred\",\"@selectedAssets\"],[[30,6],[30,7],[30,5],[30,8],[30,9],[30,3],[30,10]]],null],[1,\"\\n\"]],[5]],null],[1,\"      \"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"fromLastWeek\",\"length\"]],[[[1,\"      \"],[10,0],[14,0,\"u--col__12 cME--cardWrapper\"],[12],[1,\"\\n        \"],[10,2],[14,0,\"u--text--md u--m__tb__md\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"media_library.last_week\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[12],[1,\"\\n\"],[42,[28,[37,5],[[28,[37,5],[[30,0,[\"fromLastWeek\"]]],null]],null],null,[[[1,\"            \"],[8,[39,8],null,[[\"@addSelection\",\"@addStarred\",\"@mediaItem\",\"@openAssetModal\",\"@removeSelection\",\"@removeStarred\",\"@selectedAssets\"],[[30,6],[30,7],[30,11],[30,8],[30,9],[30,3],[30,10]]],null],[1,\"\\n\"]],[11]],null],[1,\"        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"fromLastMonth\",\"length\"]],[[[1,\"      \"],[10,0],[14,0,\"u--col__12 cME--cardWrapper\"],[12],[1,\"\\n        \"],[10,2],[14,0,\"u--text--md u--m__tb__md\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"media_library.last_month\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[12],[1,\"\\n\"],[42,[28,[37,5],[[28,[37,5],[[30,0,[\"fromLastMonth\"]]],null]],null],null,[[[1,\"            \"],[8,[39,8],null,[[\"@addSelection\",\"@addStarred\",\"@mediaItem\",\"@openAssetModal\",\"@removeSelection\",\"@removeStarred\",\"@selectedAssets\"],[[30,6],[30,7],[30,12],[30,8],[30,9],[30,3],[30,10]]],null],[1,\"\\n\"]],[12]],null],[1,\"        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"fromEarlier\",\"length\"]],[[[1,\"      \"],[10,0],[14,0,\"u--col__12 cME--cardWrapper\"],[12],[1,\"\\n        \"],[10,2],[14,0,\"u--text--md u--m__tb__md\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"media_library.earlier\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[12],[1,\"\\n\"],[42,[28,[37,5],[[28,[37,5],[[30,0,[\"fromEarlier\"]]],null]],null],null,[[[1,\"            \"],[8,[39,8],null,[[\"@addSelection\",\"@addStarred\",\"@mediaItem\",\"@openAssetModal\",\"@removeSelection\",\"@removeStarred\",\"@selectedAssets\"],[[30,6],[30,7],[30,13],[30,8],[30,9],[30,3],[30,10]]],null],[1,\"\\n\"]],[13]],null],[1,\"        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[41,[30,4],[[[1,\"      \"],[10,0],[14,0,\"u--col__12\"],[12],[1,\"\\n\"],[41,[30,14],[[[1,\"          \"],[10,1],[14,0,\"o--btn--sm u--text--light o--btn--block u--m__tb__sm\"],[12],[1,\"\\n            \"],[1,[28,[35,2],[\"shared_words.loading\"],null]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],[[[41,[30,15],[[[1,\"          \"],[11,3],[24,0,\"o--btn--lg o--btn--outline o--btn--block u--text--hl u--m__tb\"],[4,[38,3],[\"click\",[30,16]],null],[12],[1,\"\\n            \"],[1,[28,[35,2],[\"shared_phrases.load_more\"],null]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],[[[1,\"          \"],[10,1],[14,0,\"o--btn--sm u--text--light o--btn--block u--m__tb__sm\"],[12],[1,\"\\n            \"],[1,[28,[35,2],[\"shared_phrases.no_more\"],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"]],[]]]],[]]],[1,\"      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"@unstarAll\",\"item\",\"@removeStarred\",\"@hasMedia\",\"mediaItem\",\"@addSelection\",\"@addStarred\",\"@openAssetModal\",\"@removeSelection\",\"@selectedAssets\",\"mediaItem\",\"mediaItem\",\"mediaItem\",\"@queryLoadingMore\",\"@canLoadMore\",\"@loadMore\"],false,[\"if\",\"svg-jar\",\"t\",\"on\",\"each\",\"-track-array\",\"fn\",\"unless\",\"media/asset-card\"]]",
    "moduleName": "media/components/media/grid.hbs",
    "isStrictMode": false
  });
  let GridComponent = _exports.default = (_class = class GridComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "mediaLibrary", _descriptor, this);
      _initializerDefineProperty(this, "router", _descriptor2, this);
      _initializerDefineProperty(this, "starredMedia", _descriptor3, this);
    }
    get fromToday() {
      return this.args.sortedVisibleMediaItems.filter(mediaItem => mediaItem.createdToday);
    }
    get fromLastWeek() {
      return this.args.sortedVisibleMediaItems.filter(mediaItem => mediaItem.createdLastWeek);
    }
    get fromLastMonth() {
      return this.args.sortedVisibleMediaItems.filter(mediaItem => mediaItem.createdLastMonth);
    }
    get fromEarlier() {
      return this.args.sortedVisibleMediaItems.filter(mediaItem => mediaItem.createdEarlier);
    }
    get starredMediaItems() {
      return this.starredMedia.starredMediaItems;
    }
    viewStarredOnCalendar() {
      this.mediaLibrary.showStarredMedia = true;
      this.router.transitionTo('cluster.schedule');
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "mediaLibrary", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "starredMedia", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "viewStarredOnCalendar", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "viewStarredOnCalendar"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, GridComponent);
});